import moment from "moment-mini";
import isNull from "./isNull";

export const SsnValidator = (data) => {
    const inputString = data[0];
    if (inputString === "") {
        return false;
    }
    if (inputString.length === 9) {
        return false;
    } else {
        return true;
    }
}
export const FutureDate = (data, created) => {
    const currentDate = moment(created).startOf('day'); // Reset the time to the start of the day
    const givenDate = moment(data[0], "YYYY-MM-DD").startOf('day'); // Reset the time to the start of the day

    const isFutureOrToday = givenDate.isAfter(currentDate) || givenDate.isSame(currentDate);
    if (isFutureOrToday) {
        return false;
    } else {
        return true;// show error
    }
};
export const InvalidDateValidator = (data) => {
    const formatedDate = moment(data[0], 'YYYY-MM-DD', true)

    const checkDate = moment(formatedDate, "YYYY-MM-DD", true);

    const startDate = moment('1900-01-01'); // start date

    const endDate = moment();   // end date 

    const isInBetween = checkDate.isBetween(startDate, endDate);

    if (isInBetween) {

        return false;//show error

    } else {

        return true;

    }

}
export const ZeroCheckValidator = (amount) => {
    const checkCondition = (Math.ceil(amount[0]) >= 1)
    if (checkCondition) {
        return false
    } else {
        return true

    }

}

export const UnKnownCardTypeValidator = (cardType) => {
    return cardType[0] === "Unknown";
}
export const CardNumberValidator = (cardNumber) => {
    // \d for [0-9] and \D for [^0-9]
    // \w for [A - Za - z0 -9_] and \W for [^ A - Za - z0 -9_]
    // .for character classes matching everything(e.g. [\w\W], [\d\D], or[\s\S] with s flag)
    // x ? for x{ 0, 1}, x * for x{ 0, }, x + for x{ 1, }, x{ N } for x{ N, N }
    const regex = /^\d{16}$/;
    const cleaned = cardNumber[0].replace(/\D+/g, '');
    return !regex.test(cleaned);
}

export const CardExpiryYearValidator = (expiry) => {
    const expiryYear = parseInt(expiry[0])
    const currentYear = moment().year();
    const twoDigitThreshold = 50; // interpret years 00-50 as 2000-2050, and 51-99 as 1951-1999
    // Convert two-digit year to four-digit year
    const parsedYear = expiryYear < twoDigitThreshold ? 2000 + expiryYear : 1900 + expiryYear;
    const isFutureYear = parsedYear >= currentYear;
    return !(isFutureYear);
}

export const PasswordValidator = (password) => {
    //Your password must contain one number, one uppercase letter, one lowercase letter, one special character and minimum 8 characters
    const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[0-9a-zA-Z!@#$%^&*()_+]{8,}$/;
    return !passwordRegex.test(password[0]);
}
export const ConfirmPasswordValidator = (confirmPassword, password) => {
    const isSame = password === confirmPassword[0]
    return !isSame
}

export const phoneLengthValidator = (data) => data[0].length < 10;

export const paidAmountValidator = (data, paidAmount) => {
    const amount = parseFloat(data[0]);
    const paid = parseFloat(paidAmount);
    return amount > paid;
}




export const isNullValidator = (data) => {
    if (isNull(data[0])) {
        return true
    } else {
        return false
    }

};

export const booleanValidator = (data) => {
    if (data[0] === false) {
        return true
    } else {
        return false
    }

};

export const installmentValidator = (data) => {
    if (data[0] < 2) {
        return true
    } else {
        return false
    }
};

export const isOverCharacterLimitValidator = (text, limit = 500) => {
    return text[0].length > limit;
};

export const zeroCheckValidator = (data) => data[0] < 1;

export const timoutValidator = (data) => {
    if (+data[0] < 15) {
        return true // show error
    } else {
        return false
    }
}

// crete a function that check date is not past date , date should be of today or future but cant be in the past
export const pastDateValidator = (data) => {
    const formatedDate = moment(data[0]).format("YYYY-MM-DD");
    const checkDate = moment(formatedDate, "YYYY-MM-DD", true);
    const minDate = moment().startOf("day");
    if (checkDate.isSame(minDate, "day")) {
        return false;
    } else {
        return true;
    }
}
export const validatePublishableKey = (data) => {
    if (data[0].startsWith('pk_test_') || data[0].startsWith('pk_live_')) {
        return false;
    } else {
        return true;
    }
}
export const validateSecretKey = (data) => {
    if (data[0].startsWith('sk_test_') || data[0].startsWith('sk_live_')) {
        return false;
    }
    else {
        return true;
    }
}

// array length validator
export const arrayLengthValidator = (data, length) => {
    return data.length < length;
};

export const amountGreaterThanBalanceValidator = (data, balanceAmount) => {
    const amount = parseFloat(data[0]);
    const balance = parseFloat(balanceAmount);
    return amount > balance;
}

export const NpiLengthValidator = (data) => {
    const npi = data[0] || '';
    if (npi.length === 10) {
        return false;
    } else {
        return true;
    }
}

export const TaxIdLengthValidator = (data) => {
    const taxId = data[0] || '';
    if (taxId.length === 9) {
        return false;
    } else {
        return true;
    }
}
export const pastDateCheckValidator = (data) => {
    // 1. Get the date from the data array
    const checkDate = moment(data[0]).startOf('day');

    // 2. Get the start of 'today'
    const today = moment().startOf('day');

    // 3. Logic: If it's before today, it's INVALID (return true to show error)
    // If it's today or later, it's VALID (return false - no error)
    // Return true if date is in the past (invalid), false if today or future (valid)
    return checkDate.isBefore(today);
}
export const handleZeroNumericCheck = (data) => {
    if (Number(data[0]) === 0) {
        return true;
    }
    return false;
}